import { Status } from 'app/shared/model/enumerations/status.model';

export interface IParTypeIdentity {
  id?: number;
  name?: string;
  code?: string;
  nameAr?: string;
  nameEn?: string;
  status?: Status;
}

export const defaultValue: Readonly<IParTypeIdentity> = {};
